module.exports = __webpack_public_path__ + "static/media/layers.ee07997e.svg";